/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * NileGridHeadItem CSS
 */
export const styles = css`
  :host {
    --padding: var(--nile-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-10px, var(--ng-spacing-3xl));
    --height: 50px;
    position: relative;
    box-sizing: border-box;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: var(--padding);
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-secondary));
    font-size: var(--nile-font-size-small, var(--ng-font-size-text-xs));
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-semibold));
    font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
    min-height: var(--height);
    display: flex;
    align-items: center;
    color: var(--nile---nile-colors-dark-900, var(--ng-colors-text-quaternary-500));
  }

  .head-item-base {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::slotted(*) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :host(:last-child) .resize-handle {
    border-right: none;
    display: none;
  }

  .resize-handle {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    cursor: ew-resize;
    touch-action: none;
    width: 2px;
    border-right: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
  }

  :host(.shadow-right) {
    box-shadow: var(--nile-box-shadow-13, var(--ng-shadow-xs));
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-secondary));
    z-index: 1;
  }

  :host(.shadow-left) {
    box-shadow: var(--nile-box-shadow-13, var(--ng-shadow-xs));
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-secondary));
    z-index: 2;
  }

  :host(.head-rowspan) {
    position: absolute;
    z-index: 1;
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-secondary));
  }
`;

export default [styles];
